export async function getLegalEntity(legalEntityRepository) {
  return legalEntityRepository.get();
};
